import Poptip from './poptip.vue';

export default Poptip;


// WEBPACK FOOTER //
// ./src/components/poptip/index.js